export default __webpack_public_path__ + "static/media/console.75a5b846.svg";